// ─── Operator colors ─────────────────────────────────────────────────────────

export const operatorColors: Record<string, string> = {
  Orange: '#FF7900',
  SFR: '#E2001A',
  Bouygues: '#009CDC',
};

export const defaultColor = '#94a3b8';

export const operatorImages: Record<string, string> = {
  Orange: '/images/operators/orange.webp',
  SFR: '/images/operators/sfr.svg',
  Bouygues: '/images/operators/bouygues.png',
};

// ─── Site colors ─────────────────────────────────────────────────────────────

export const siteColors = ['#f59e0b', '#f97316', '#ef4444', '#8b5cf6', '#06b6d4'];
export const otherSiteColor = '#cbd5e1';
